var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.276,
    height: 10.276
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Icon - Clock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.035 8.24a4.388 4.388 0 116.206 0 4.389 4.389 0 01-6.206 0z",
    "data-name": "Path 4297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.137 5.138L4.029 6.246",
    "data-name": "Line 549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.137 5.138V2.715",
    "data-name": "Line 550"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC4yNzYiIGhlaWdodD0iMTAuMjc2Ij48ZyBmaWxsPSJub25lIiBzdHJva2U9IiMxMDE4MWMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGRhdGEtbmFtZT0iSWNvbiAtIENsb2NrIj48cGF0aCBkPSJNMi4wMzUgOC4yNGE0LjM4OCA0LjM4OCAwIDEgMSA2LjIwNiAwIDQuMzg5IDQuMzg5IDAgMCAxLTYuMjA2IDBaIiBkYXRhLW5hbWU9IlBhdGggNDI5NyIvPjxwYXRoIGQ9Ik01LjEzNyA1LjEzOCA0LjAyOSA2LjI0NiIgZGF0YS1uYW1lPSJMaW5lIDU0OSIvPjxwYXRoIGQ9Ik01LjEzNyA1LjEzOFYyLjcxNSIgZGF0YS1uYW1lPSJMaW5lIDU1MCIvPjwvZz48L3N2Zz4=";
export { SvgClock as ReactComponent };